import React, { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../shared/lib/queryClient';
import { useUIStore } from '../shared/lib/uiStore';
import { AuthProvider } from '../contexts/AuthContext';
import { bootstrapViewerManifest } from '../features/pdm/services/viewerBootstrap';

function ThemeInitializer({ children }: { children: React.ReactNode }) {
  const theme = useUIStore((s) => s.theme);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    document.documentElement.classList.toggle('light', theme === 'light');

    const themeColor = theme === 'dark' ? '#111827' : '#f5f5f7';
    const themeMeta = document.querySelector('meta[name="theme-color"]');
    if (themeMeta) {
      themeMeta.setAttribute('content', themeColor);
    }
  }, [theme]);

  useEffect(() => {
    void bootstrapViewerManifest();
  }, []);

  return <>{children}</>;
}

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeInitializer>
        <AuthProvider>
          {children}
        </AuthProvider>
      </ThemeInitializer>
    </QueryClientProvider>
  );
}
